import React from "react";
import { Skeleton, Form, Icon } from "antd";
import moment from "moment";
import ServiceType from "../../../common/FormSections/ServiceType";
import Routes from "../../../common/FormSections/Routes";
import Dispatcher from "../../../common/FormSections/Dispatcher";
import Performer from "../../../common/FormSections/Performer";
import VehicleTypes from "../../../../Transport/components/common/formSection/Fields/TypeName";
import Vehicle from "../../../common/FormSections/Vehicle";
import Drivers from "../../../common/FormSections/Drivers";
import SelectCustomer from "../../../common/FormSections/SelectCustomer";
import Email from "../../../common/FormSections/Email";
import Phone from "../../../common/FormSections/Phone";
import Customer from "../../../common/FormSections/Customer";
import OrderNumber from "../../../common/FormSections/OrderNumber";
import Payroad from "../../../common/FormSections/Payroad";
import Monetization from "../../../common/FormSections/Monetization";
import PriceFinalNDS from "../../../common/FormSections/Price/PriceFinalNDS";
import PriceNoNds from "../../../common/FormSections/Price/PriceNoNds";
import PriceFinal from "../../../common/FormSections/Price/PriceFinal";
import TotalPrice from "../../../common/FormSections/Price/TotalPrice";
import MonetizationTemplates from "../../../common/FormSections/MonetizationTemplates";
import AdditionalServices from "../../../common/FormSections/AdditionalServices";
import { Divider } from "antd/es";
import OfferPaymentType from "../../../common/FormSections/OfferPaymentType";
import SurchargePayment from "../../../common/FormSections/SurchargePayment";
import SurchargePaymentDate from "../../../common/FormSections/SurchargePaymentDate";
import RefundFreighterDate from "../../../common/FormSections/RefundFreighterDate";
import OfferDocuments from "../../../common/FormSections/OfferDocuments";

class OrderInfo extends React.Component {
  state = {
    monetizationFieldsDisabled: false,
    monetizationSectionPass: false
  };

  checkCompleted = name => {
    return this.props.formProgress.some(
      f => f.name === name && f.completed === true
    );
  };

  toggleMonetizationFields = value => {
    this.setState({
      monetizationFieldsDisabled: value
    });
  };

  passMonetizationSection = () => {
    this.setState(
      {
        monetizationSectionPass: !this.state.monetizationSectionPass
      },
      () => {
        this.props.form.setFieldsValue({
          monetizationIsPassed: this.state.monetizationSectionPass
        });
      }
    );
  };

  render() {
    const {
      typeForm,
      form,
      isEditable,
      validateField,
      showAllFields,
      handleClickShowAllFields,
      componentRef
    } = this.props;
    console.log(this.props.form.getFieldValue("monetizationIsPassed"));
    const customerFilled = this.checkCompleted("customer");
    const serviceTypeFilled = this.checkCompleted("serviceType");
    const routeProgramFilled = this.checkCompleted("routeProgram");
    const performerFilled = this.checkCompleted("performer");
    // const monetizationFilled =
    //   this.checkCompleted("monetization") || this.state.monetizationSectionPass;
    const priceFilled = this.checkCompleted("price");
    const surcharge = this.checkCompleted("surcharge");
    // Переменные для разработки
    // const customerFilled = true;
    // const serviceTypeFilled = true;
    // const routeProgramFilled = true;
    // const performerFilled = true;
    // const monetizationFilled = true;
    // const priceFilled = true;
    // const surcharge = true;

    const totalPrice = form.getFieldValue("totalPrice");
    const sumUndestributedPrice = (
      totalPrice,
      paySum = 0,
      predPaySum = 0,
      postPaySum = 0
    ) => {
      if (totalPrice) {
        return totalPrice - predPaySum - paySum - postPaySum;
      } else {
        return null;
      }
    };
    const predPaySum =
      form.getFieldValue("predPay") &&
      form.getFieldValue("predPay").length > 0 &&
      form
        .getFieldValue("predPay")
        .map(item =>
          form.getFieldValue("predPayPrice" + item)
            ? parseInt(form.getFieldValue("predPayPrice" + item))
            : 0
        )
        .reduce((acc, curr) => acc + curr);
    const paySum = form.getFieldValue("payPrice");
    const postPaySum =
      form.getFieldValue("postPay") &&
      form.getFieldValue("postPay").length > 0 &&
      form
        .getFieldValue("postPay")
        .map(item =>
          form.getFieldValue("postPayPrice" + item)
            ? parseInt(form.getFieldValue("postPayPrice" + item))
            : 0
        )
        .reduce((acc, curr) => acc + curr);

    return (
      <div className="card-info">
        <Form layout="inline">
          <div
            className="offer-card__section"
            style={{ padding: "16px 0 0 0" }}
          >
            {typeForm === "view" ? (
              this.props.data && Object.keys(this.props.data).length ? (
                <>
                  <OrderNumber
                    form={form}
                    disabled={!isEditable}
                    handleClickShowAllFields={handleClickShowAllFields}
                    componentRef={componentRef}
                  />
                  <Customer form={form} disabled={!isEditable} />
                  <Phone form={form} disabled={!isEditable} />
                  <Email form={form} disabled={!isEditable} />
                  <div className="offer-create__section offer-object section-2">
                    <ServiceType
                      form={form}
                      disabled={!isEditable}
                      validateField={validateField}
                    />
                  </div>
                  <Divider />
                  <Routes
                    form={form}
                    disabled={!isEditable}
                    entity="orderCreate"
                  />
                  {showAllFields && (
                    <Payroad form={form} disabled={!isEditable} />
                  )}
                  <Divider />
                  <Performer
                    form={form}
                    disabled={!isEditable}
                    additionalComponent={
                      typeForm === "view" && (
                        <div className="show-all">
                          <div
                            className="show-all__btn"
                            onClick={() => {
                              handleClickShowAllFields(!showAllFields);
                            }}
                          >
                            {showAllFields
                              ? "Скрыть параметры"
                              : "Показать еще параметры"}
                            <Icon type={showAllFields ? "up" : "down"} />
                          </div>
                        </div>
                      )
                    }
                  />
                  {showAllFields ? (
                    <>
                      {/*<Dispatcher form={form} disabled={!isEditable} />*/}
                      {/*<div className="offer-card__item">*/}
                      {/*  <VehicleTypes form={form} disabled={!isEditable} />*/}
                      {/*</div>*/}
                      {/*<Vehicle form={form} disabled={!isEditable} />*/}
                      {/*<Drivers form={form} disabled={!isEditable} />*/}
                      <Divider />
                      <div className="offer-card__section">
                        <MonetizationTemplates
                          form={form}
                          disabled={!isEditable}
                          toggleMonetizationFields={
                            this.toggleMonetizationFields
                          }
                        />
                        <Monetization
                          form={form}
                          disabled={
                            !isEditable ||
                            !this.state.monetizationFieldsDisabled
                          }
                          disabledKp1urc={!isEditable}
                        />
                      </div>
                      <div className="offer-card__section">
                        <PriceNoNds form={form} disabled={!isEditable} />
                        <AdditionalServices
                          form={form}
                          disabled={!isEditable}
                          typeForm={"order"}
                        />
                        <PriceFinal
                          form={form}
                          disabled={true}
                          parent="order"
                        />
                        <PriceFinalNDS
                          form={form}
                          disabled={true}
                          parent="order"
                        />
                        <TotalPrice
                          form={form}
                          disabled={true}
                          parent="order"
                        />

                        {/*
                  <OfferPrice form={form} disabled={!isEditable} />
                  <Price form={form} disabled={!isEditable} />
                  <OrderPrice form={form} disabled={!isEditable} />
                  */}
                      </div>

                      <div className="offer-card__section">
                        <OfferPaymentType
                          form={form}
                          disabled={!isEditable}
                          sumUndestributedPrice={sumUndestributedPrice(
                            totalPrice,
                            paySum,
                            predPaySum,
                            postPaySum
                          )}
                        />
                        <SurchargePayment form={form} disabled={!isEditable} />
                        <SurchargePaymentDate
                          form={form}
                          disabled={!isEditable}
                        />
                        <RefundFreighterDate
                          form={form}
                          disabled={!isEditable}
                        />
                      </div>

                      <div className="offer-card__section">
                        <OfferDocuments
                          form={form}
                          disabled={!isEditable}
                          parent="order"
                          typeForm="view"
                        />
                      </div>
                    </>
                  ) : null}
                </>
              ) : (
                <Skeleton active />
              )
            ) : null}

            {typeForm === "create" ? (
              <>
                <SelectCustomer form={form} disabled={!isEditable} />
                {customerFilled && (
                  <div className="offer-create__section offer-object section-2">
                    <ServiceType
                      form={form}
                      disabled={!isEditable}
                      validateField={validateField}
                    />
                  </div>
                )}
                {serviceTypeFilled && (
                  <>
                    <Divider />
                    <Routes
                      form={form}
                      disabled={!isEditable}
                      entity="orderCreate"
                    />
                    <Payroad form={form} disabled={!isEditable} />
                  </>
                )}
                {routeProgramFilled && (
                  <>
                    <Divider />
                    <div
                      className="offer-card__section"
                      style={{ paddingTop: 0 }}
                    >
                      <Performer
                        form={form}
                        disabled={!isEditable}
                        additionalComponent={
                          typeForm === "view" && (
                            <div className="show-all">
                              <div
                                className="show-all__btn"
                                onClick={() => {
                                  handleClickShowAllFields(!showAllFields);
                                }}
                              >
                                {showAllFields
                                  ? "Скрыть параметры"
                                  : "Показать еще параметры"}
                                <Icon type={showAllFields ? "up" : "down"} />
                              </div>
                            </div>
                          )
                        }
                      />
                      <Dispatcher form={form} disabled={!isEditable} />
                      <div className="offer-card__item">
                        <VehicleTypes form={form} disabled={!isEditable} />
                      </div>
                      <Vehicle form={form} disabled={!isEditable} />
                      <Drivers form={form} disabled={!isEditable} />
                    </div>
                  </>
                )}
                {performerFilled && (
                  <>
                    <div className="offer-card__section">
                      <MonetizationTemplates
                        form={form}
                        disabled={!isEditable}
                        toggleMonetizationFields={this.toggleMonetizationFields}
                        passMonetizationSection={this.passMonetizationSection}
                        monetizationSectionPass={
                          this.state.monetizationSectionPass
                        }
                      />
                      <Monetization
                        form={form}
                        disabled={
                          !isEditable || !this.state.monetizationFieldsDisabled
                        }
                        disabledKp1urc={!isEditable}
                        monetizationSectionPass={
                          this.state.monetizationSectionPass
                        }
                      />
                    </div>
                    <div className="offer-card__section">
                      <PriceNoNds form={form} disabled={!isEditable} />
                      <AdditionalServices
                        form={form}
                        disabled={!isEditable}
                        typeForm={"order"}
                      />
                      <PriceFinal form={form} disabled={true} parent="order" />
                      <PriceFinalNDS
                        form={form}
                        disabled={true}
                        parent="order"
                      />
                      <TotalPrice form={form} disabled={true} parent="order" />
                    </div>
                  </>
                )}
                {priceFilled && (
                  <div className="offer-card__section">
                    <OfferPaymentType
                      form={form}
                      disabled={!isEditable}
                      sumUndestributedPrice={sumUndestributedPrice(
                        totalPrice,
                        paySum,
                        predPaySum,
                        postPaySum
                      )}
                    />
                  </div>
                )}
                {sumUndestributedPrice(
                  totalPrice,
                  paySum,
                  predPaySum,
                  postPaySum
                ) === 0 && (
                  <div className="offer-card__section">
                    <SurchargePayment form={form} disabled={!isEditable} />
                    <SurchargePaymentDate form={form} disabled={!isEditable} />
                    <RefundFreighterDate form={form} disabled={!isEditable} />
                  </div>
                )}

                {surcharge && (
                  <div className="offer-card__section">
                    <OfferDocuments
                      form={form}
                      disabled={!isEditable}
                      noFreightOrder={this.props.noFreightOrder}
                    />
                  </div>
                )}
              </>
            ) : null}
          </div>
        </Form>
      </div>
    );
  }
}

class OrderInfoData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      default: {
        customerType: "select",
        orderStatus: null,
        serviceType: null,
        selectedVehicle: null
      }
    };
    this.defaultProfileData = {};
    this.flagInitEditing = false;
  }
  componentDidMount() {
    this.initEditing();
  }
  componentDidUpdate(prevProps, prevState) {
    this.initEditing();
    //if (this.props.checkFormErrors) {
    //  this.props.checkFormErrors(this.props.name);
    //}
  }
  getValueByFieldName(name, val) {
    if (name.includes("Date")) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }
  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    } else {
      this.formRef = null;
    }
    this.props.setForm(this.props.name, this.formRef);
  };

  //
  initEditing = () => {
    let { isEditable, order: dataProps, orderId } = this.props;
    if (
      !this.flagInitEditing &&
      isEditable &&
      ((dataProps && orderId > 0) || orderId === 0)
    ) {
      this.flagInitEditing = true;

      let newEditData = {};
      if (dataProps && orderId !== 0) {
        Object.keys(dataProps).forEach(item => {
          newEditData[item] = {
            value: dataProps[item]
          };
        });
      }
      // add default value
      Object.keys(this.state.default).forEach(item => {
        if (!newEditData[item]) {
          newEditData[item] = this.state.default[item]
            ? { value: this.state.default[item] }
            : {};
        }
      });
      this.setState({ data: newEditData }, () => {
        // проверить все поля на валидность
        // if (this.formRef) {
        //   this.formRef.validateFields((errors, values) => {
        //     this.changeValues(values);
        //   });
        // }
      });
    } else if (!isEditable && this.flagInitEditing) {
      this.flagInitEditing = false;
    }
  };

  handleFieldsChange = values => {
    // Если есть серверные ошибки, и это поле изменилось, то удаляем ошибку из store
    if (this.props.createErrors) {
      Object.keys(values).forEach(name => {
        if (
          this.props.createErrors &&
          this.props.createErrors.data &&
          this.props.createErrors.data[name]
        ) {
          if (values[name].errors) {
            delete values[name].errors;
          }
          this.props.clearError(name);
        }
      });
    }
    this.setState(
      state => {
        return {
          data: {
            ...state.data,
            ...values
          }
        };
      },
      () => {
        this.changeValues(this.state.data);
      }
    );
  };

  validateField = nameField => {
    let result =
      this.formRef &&
      this.formRef.isFieldTouched(nameField) &&
      this.formRef.getFieldError(nameField);
    // todo Проверить есть ли в сторе ошибки от сервера
    //let err = 'Уже есть такой пользователь';
    //if(nameField === 'phone')
    return {
      status: result ? "error" : "",
      help: result || ""
    };
  };

  changeValues = values => {
    if (this.formRef) {
      // Обновляем прогресс заполнения
      this.props.updateProgress(values);
    }
  };

  //
  render() {
    const { isEditable } = this.props;
    const data = isEditable
      ? this.state.data
      : this.props.order || this.defaultProfileData;
    return (
      <FormOrderInfo
        {...this.props}
        data={data}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
        handleFieldsChange={this.handleFieldsChange}
        validateField={this.validateField}
      />
    );
  }
}

const FormOrderInfo = Form.create({
  name: "formOrderInfo",
  onFieldsChange(props, changedFields) {
    props.handleFieldsChange(changedFields);
  },
  mapPropsToFields(props) {
    let obj = {};
    props.data &&
      Object.keys(props.data).forEach(name => {
        /* todo разобраться с серверыными ошибками*/
        let err = {};
        if (
          props.createErrors &&
          props.createErrors.data &&
          props.createErrors.data[name]
        ) {
          err.errors = [new Error(props.createErrors.data[name])];
        }

        let all = true;
        // Маршрут
        if (name === "routes") {
          let routes = props.isEditable
            ? props.data[name].value
            : props.data[name];
          routes &&
            routes.forEach((item, index) => {
              obj["route" + index] = Form.createFormField({
                value: props.isEditable
                  ? item.value
                    ? item.value
                    : item.route
                  : item.route
              });
              obj["routeDuration" + index] = Form.createFormField({
                value: moment(item.duration, "HH:mm")
              });
            });
        }
        // Монетизация
        if (name === "monetization" && props.data[name]) {
          all = false;
          const {
            name: monetizationName = null,
            template: monetizationTemplate = null
          } = props.data[name];
          obj[name + ".name"] = Form.createFormField({
            value: props.isEditable
              ? monetizationName && monetizationName.value
              : monetizationName
          });
          if (monetizationTemplate) {
            Object.keys(monetizationTemplate).forEach(key => {
              let keyName = name + ".template." + key;
              if (
                monetizationTemplate[key] &&
                monetizationTemplate[key].constructor === Object
              ) {
                Object.keys(monetizationTemplate[key]).forEach(key2 => {
                  obj[keyName + "." + key2] = Form.createFormField({
                    value: props.isEditable
                      ? monetizationTemplate[key][key2].value
                      : monetizationTemplate[key][key2]
                  });
                });
              } else {
                obj[keyName] = Form.createFormField({
                  value: props.getValueByFieldName(
                    keyName,
                    props.isEditable
                      ? monetizationTemplate[key].value
                      : monetizationTemplate[key]
                  )
                });
              }
            });
          }
        }
        // На этапе маппинга локального стейта я вкорячиваю значения в поля, которые считаются динамически.
        // как-то так. ¯\_(ツ)_/¯
        if (name === "priceNoNds" && props.data[name]) {
          let priceFinal = props.isEditable
            ? props.data[name].value
            : props.data[name];

          const nds =
            props.performers &&
            props.performers.find(item =>
              props.isEditable
                ? item.companyId === props.data["performer"].value
                : item.companyId === props.data["performer"]
            ) &&
            !!props.performers.find(item =>
              props.isEditable
                ? item.companyId === props.data["performer"].value
                : item.companyId === props.data["performer"]
            ).nds;

          if (props.data.hasOwnProperty("additionalServices")) {
            if (props.isEditable) {
              props.data["additionalServices"].value.forEach(item => {
                const servicePrice =
                  props.data["serviceAdditionalPrice" + item] &&
                  props.data["serviceAdditionalPrice" + item].value;
                if (servicePrice) {
                  priceFinal += parseInt(servicePrice);
                }
              });
            } else {
              props.data["additionalServices"].forEach(item => {
                const servicePrice =
                  props.data["serviceAdditionalPrice" + item];
                if (servicePrice) {
                  priceFinal += parseInt(servicePrice);
                }
              });
            }
          }
          const totalPrice = nds
            ? priceFinal + Math.round(priceFinal * 0.2)
            : priceFinal;

          obj["priceFinal"] = Form.createFormField({
            value: props.getValueByFieldName(name, priceFinal)
          });
          obj["priceFinalNDS"] = Form.createFormField({
            value: props.getValueByFieldName(
              name,
              nds ? Math.round(priceFinal * 0.2) : 0
            )
          });
          obj["totalPrice"] = Form.createFormField({
            value: props.getValueByFieldName(name, totalPrice)
          });
        }

        if (all) {
          obj[name] = Form.createFormField({
            ...(props.isEditable ? props.data[name] : {}),
            ...(props.isEditable ? err : {}),
            value: props.getValueByFieldName(
              name,
              props.isEditable ? props.data[name].value : props.data[name]
            )
          });
        }
      });
    return obj;
  },
  onValuesChange(props, values) {}
})(OrderInfo);

export default OrderInfoData;
